module.exports = __webpack_public_path__ + "img/club-golf-vilaverde.0b916e93.jpg";